import React, { createContext, useContext } from 'react';

// A preview shell can qualify the whole subtree once, without page-specific prop forwarding.
export const SnapshotNoticeVisibility = createContext(true);

/** A read-only snapshot is unverified until integration supplies its provenance.
 * Hosts can suppress this when supplying verified data or the global fixture notice. */
export default function SnapshotNotice({ visible = true }) {
  const inheritedVisibility = useContext(SnapshotNoticeVisibility);
  if (!visible || !inheritedVisibility) return null;
  return <p role="note" data-snapshot-notice="true" style={{ padding: '12px 16px', margin: 0,
    color: 'var(--text-hi)', background: 'var(--surface-2)', borderBottom: '1px solid var(--line)' }}>
    Preview data · account details, amounts and history shown here are unverified examples.
  </p>;
}
